import { config } from "@/helpers";
import { getStore } from "@/store";
import { AxiosResponse } from "axios";
import { session } from "./session";
import { Api, ContentType } from "./v1_0";

let clientApi: Api<unknown> | null = null;

export const useApi = (): Api<unknown> => {
  if (null !== clientApi) {
    return clientApi;
  }

  const api = new Api({
    baseURL: config.apiUrl,
    securityWorker: () => ({
      headers: {
        Accept: ContentType.Json,
        "X-App-Version": config.version,
        "X-User-Agent": `Yoney-${config.environment}-${config.version}`,
      },
      format: "json",
    }),
  });

  api.instance.interceptors.request.use((apiConfig) => {
    if (
      ["/login", "/token/refresh", "/v1.0/account/signup"].includes(
        apiConfig.url || ""
      )
    ) {
      return apiConfig;
    }

    if (session.hasAccessToken()) {
      apiConfig.headers["Authorization"] = `Bearer ${session.accessToken}`;
    }

    return apiConfig;
  });

  api.instance.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error) => {
      if (["/login", "/token/refresh"].includes(error.config.url)) {
        throw error;
      }

      if (error.config._retry) {
        throw error;
      }

      switch (error.request.status) {
        case 401:
          const store = getStore();

          try {
            if (!session.refreshToken) {
              store.auth.signOut();

              await session.clear();

              store.app.logged = false;

              throw error;
            }

            const {
              data: { token: accessToken, refreshToken },
            } = await api.token.appHttpApiSecurityControllerRefresh({
              refresh_token: session.refreshToken,
            });

            session.accessToken = accessToken;
            session.refreshToken = refreshToken;

            store.app.logged = true;

            return api.instance(error.config);
          } catch (err) {
            console.error(err);
            store.logging.capture(err);
            store.auth.signOut();

            await session.clear();

            store.app.logged = false;

            throw err;
          }

        default:
          throw error;
      }
    }
  );

  clientApi = api;

  return api;
};

export const updateApi = (apiHost: string): void => {
  // config.apiUrl = `https://${apiHost}/api`;

  clientApi = null;
};
